import { Paths } from 'shared/routes/paths';
import { UtmParameters } from 'shared/types/utm-parameters';

export enum QueryParamOptions {
  OobCode = 'oobCode',
  Premium = 'premium',
  OnboardingPremium = 'onboarding-premium',
  Purchase = 'purchase',
  Search = 'search',
  C = 'c',
  ExternalId = 'externalId',
}

export const globalQueryParamOptions: (QueryParamOptions | UtmParameters)[] = [
  ...Object.values(QueryParamOptions),
  ...Object.values(UtmParameters),
];

const baseAllowedQueryParamOptions = [
  ...Object.values(UtmParameters),
  QueryParamOptions.OobCode,
  QueryParamOptions.C,
  QueryParamOptions.Premium,
];

export const pathAllowedQueryParamOptions: Record<
  Paths,
  (QueryParamOptions | UtmParameters)[]
> = {
  [Paths.Home]: baseAllowedQueryParamOptions,
  [Paths.Inbox]: baseAllowedQueryParamOptions,
  [Paths.Upcoming]: baseAllowedQueryParamOptions,
  [Paths.AllTasks]: baseAllowedQueryParamOptions,
  [Paths.TaskCreate]: baseAllowedQueryParamOptions,
  [Paths.Completed]: baseAllowedQueryParamOptions,
  [Paths.Goals]: baseAllowedQueryParamOptions,
  [Paths.GoalsRoadmap]: baseAllowedQueryParamOptions,
  [Paths.GoalsCompleted]: baseAllowedQueryParamOptions,
  [Paths.GoalsArchived]: baseAllowedQueryParamOptions,
  [Paths.GoalsThisYear]: baseAllowedQueryParamOptions,
  [Paths.GoalsNextYear]: baseAllowedQueryParamOptions,
  [Paths.GoalsUnplanned]: baseAllowedQueryParamOptions,
  [Paths.GoalDetail]: baseAllowedQueryParamOptions,
  [Paths.GoalDetailRoadmap]: baseAllowedQueryParamOptions,
  [Paths.GoalDetailProgress]: baseAllowedQueryParamOptions,
  [Paths.GoalDetailTasks]: baseAllowedQueryParamOptions,
  [Paths.GoalTemplates]: [
    ...baseAllowedQueryParamOptions,
    QueryParamOptions.Search,
  ],
  [Paths.GoalsCalendar]: baseAllowedQueryParamOptions,
  [Paths.LifeAreas]: baseAllowedQueryParamOptions,
  [Paths.LifeAreaDetail]: baseAllowedQueryParamOptions,
  [Paths.LifeAreaDetailVision]: baseAllowedQueryParamOptions,
  [Paths.LifeAreaDetailGoals]: baseAllowedQueryParamOptions,
  [Paths.LifeAreaDetailTasks]: baseAllowedQueryParamOptions,
  [Paths.Habits]: baseAllowedQueryParamOptions,
  [Paths.HabitsCompleted]: baseAllowedQueryParamOptions,
  [Paths.Login]: baseAllowedQueryParamOptions,
  [Paths.Signup]: baseAllowedQueryParamOptions,
  [Paths.ForgotPassword]: baseAllowedQueryParamOptions,
  [Paths.ResetPassword]: baseAllowedQueryParamOptions,
  [Paths.CompleteSignup]: baseAllowedQueryParamOptions,
  [Paths.VerifyEmail]: baseAllowedQueryParamOptions,
  [Paths.Insights]: baseAllowedQueryParamOptions,
  [Paths.TagDetail]: baseAllowedQueryParamOptions,
  [Paths.SmartListDetail]: baseAllowedQueryParamOptions,
  [Paths.Search]: [...baseAllowedQueryParamOptions, QueryParamOptions.Search],
  [Paths.Trash]: baseAllowedQueryParamOptions,
};
